import React, { useState, useEffect } from "react";
import { AutoComplete } from "antd";
import { OptionType, SearchInBoardPropsType } from "../../type";
import { DefaultOptionType as Option } from "antd/es/select";

import styles from "../../style/index.module.scss";
import { SearchIcon } from "../../assets";
// 扁平化 options 并生成完整路径的 label
const flattenOptionsWithPath = (options: Option[]): Option[] => {
  let result: OptionType[] = [];

  const flatten = (items: Option[], currentPath: string[], currentValue: (string | number)[]) => {
    let newResult = [];

    items.forEach((item) => {
      let currentLabel = typeof item.label === "string" ? item.label : item.originalLabel;

      const newPath = [...currentPath, currentLabel];

      const newValue = [...currentValue, item.value];

      const labelPath = newPath;
      let hasChildren = Boolean(item.children?.length);

      let newItem = {
        value: newValue,
        label: typeof item.label === "string" ? item.label : item.originalLabel,
        labelPath,
        level: newPath.length,
        isLasted: !hasChildren
      } as any;

      newResult.push(newItem);

      if (item.children) {
        newItem.children = flatten(item.children, newPath, newValue);
      }
    });

    return newResult;
  };

  result = flatten(options, [], []);
  //
  return result;
};

const highlightMatch = (text: string, searchValue: string) => {
  const regex = new RegExp(`(${searchValue})`, "gi");
  return text.replace(regex, (match) => `<span class=${styles.highlight}>${match}</span>`);
};

const SearchInBoard = ({
  options,
  setValue,
  searchBoardPlaceholder,
  searchValue,
  setSearchValue,
  onChange,
  onlySearchInLastedLayer,
  renderSearchEmpty
}: SearchInBoardPropsType) => {
  const [optionsAfterFilter, setOptions] = useState<Option[]>([]);
  const [flattenedOptions, setFlattenedOptions] = useState<Option[]>([]);
  console.log("optionsAfterFilter", optionsAfterFilter);

  useEffect(() => {
    setFlattenedOptions(flattenOptionsWithPath(options));
  }, [options]);

  const handleSearch = (value: string) => {
    setSearchValue(value);
    let result = [];
    const appendChild = (item, result = []) => {
      if (item.children) {
        item.children.forEach((newItem) => {
          if (newItem.children) {
            appendChild(newItem, result);
          } else {
            result.push(newItem);
          }
        });
      }
    };

    const forEachFilter = (filter = []) => {
      //
      filter.filter((item) => {
        if (onlySearchInLastedLayer && !item.isLasted) {
          let isFullMatch =
            (typeof item.label === "string" ? item.label : item.originalLabel).toLowerCase() ===
            value.toLowerCase();
          if (isFullMatch && item.children) {
            // append all child
            appendChild(item, result);
          } else if (item.children) {
            forEachFilter(item.children);
          }
          return false;
        }

        if (
          (typeof item.label === "string" ? item.label : item.originalLabel)
            .toLowerCase()
            .includes(value.toLowerCase())
        ) {
          //
          result.push(item);
        }
      });
    };
    forEachFilter(flattenedOptions);

    const filteredOptions: Option[] = result.map((item) => {
      return {
        ...item,
        value: item.value,
        currentLabel: typeof item.label === "string" ? item.label : item.originalLabel,
        title: item.labelPath.join(" / "),
        label: (
          <span
            dangerouslySetInnerHTML={{ __html: highlightMatch(item.labelPath.join(" / "), value) }}
          />
        )
      };
    });

    setOptions(
      filteredOptions.sort((a, b) => {
        return b.level - a.level;
      })
    );
  };

  const handleOnSelect = (data, option) => {
    let newOptions = (option.labelPath || []).map((label, index) => {
      return { label, value: data[index] };
    });
    onChange(data, newOptions);
    // setValue(data);
    setSearchValue(option.currentLabel);
  };

  return (
    <div className={styles.autoCompleteWrapper}>
      <AutoComplete
        options={
          Boolean(searchValue?.length)
            ? Boolean(optionsAfterFilter.length)
              ? optionsAfterFilter
              : renderSearchEmpty
              ? [{}]
              : null
            : []
        }
        onSearch={handleSearch}
        value={searchValue}
        placeholder={searchBoardPlaceholder || "Search"}
        getPopupContainer={(node) => node.parentElement}
        onSelect={handleOnSelect}
        className={styles.overrideAutoComplete}
        dropdownRender={(menu) => {
          return (
            <>
              {searchValue && searchValue.length
                ? optionsAfterFilter.length
                  ? menu
                  : renderSearchEmpty?.(searchValue) || null
                : null}
            </>
          );
        }}
        prefix={<SearchIcon />}
      />
    </div>
  );
};

export default SearchInBoard;
